<template>
    <div class="dropdown" v-click-outside="onClose">
        <button class="btn btn-default btn-xs transparent" type="button" @click="isOpen = !isOpen">
            <template v-if="selected">{{ selected.name | truncate(25) }}</template>
            <template v-else>{{ placeholder }}</template>
            <span class="caret" :class="{ 'up' : !isOpen , 'down' : isOpen}"></span>
        </button>
        <ul class="dropdown-menu full-screen" :class="{'open' : isOpen}">
            <li v-for="(option,index) in options" :key="index" :value="option.value" @click="onSelectOption(option)"><a href="javascript:void(0);">{{option.name}}</a></li>
        </ul>
    </div>
</template>

<script>
export default {
  props: ["value", "placeholder", "options"],
  data: function() {
    return {
      isOpen: false
    };
  },
  computed: {
    selected: function() {
      return this.value;
    }
  },
  methods: {
    onSelectOption: function(value) {
      this.$emit("input", value);
      this.onClose()
    },
    onClose: function() {
        this.isOpen = false;
    }
  },
  directives: {
    "click-outside": {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${
            binding.expression
          }' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/elements/dropdown.vue